import type { OnyxIconName } from '../icons/interfaces';

export const ONYX_ICON_PICKER_ICONS: OnyxIconName[] = [
  'semi-truck-filled',
  'straight-truck-filled',
  'van-filled',
  'semi-trailer-filled',
  'trailer-filled',
  'train-filled',
  'ferry-filled',
  'port-outlined',
  'airport-filled',
  'base-filled',
  'gas-station-filled',
  'vehicle-loading-circle-filled',
  'vehicle-unloading-circle-filled',
  'parking-circle-filled',
  'customs-filled',
  'car-wash-filled',
  'road-filled',
  'tunnel-filled',
  'location-filled',
  'new-order-filled',
  'good-filled',
  'group-filled',
  'two-users-filled',
  'delegation-filled',
  'service-filled',
  'list-outlined',
  'map-view-filled',
  'locked-filled',
  'unlocked-filled',
  'manual-filled',
  'decision-filled',
  'rating-filled',
  'error-neutral-filled',
  'verified-filled',
  'check-circle-filled',
  'no-entry-filled',
  'clear-filled',
  'finance-filled',
  'help-filled',
  'coil-well-filled',
  'clock-filled',
  'hourglass-top-filled',
  'calendar-filled',
  'calendar-alt-filled',
  'date-end-filled',
  'contractor-filled',
  'offer-filled',
  'bookmark-filled',
  'more-alt-filled',
  'more-filled',
  'ftl-outlined',
  'ltl-outlined',
  'vacation-filled',
  'forward-filled',
  'arrow-upward-outlined',
  'arrow-downward-outlined',
  'border-crossing-filled',
  'vehicle-off-route-filled',
  'compass-right-filled',
  'exchange-filled',
  'sent-filled',
  'requirements-food-outlined',
  'dynamic-filled',
  'hashtag-filled',
  'requirements-adr-outlined',
  'requirements-adr-tank-outlined',
  'requirements-forklift-filled',
  'requirements-didb-outlined',
] as const;
